export default "__VITE_ASSET__wdUY_HBC__"